import $ from "jquery";

(function triggerClickToInitReviewSlider() {
  $(document).on("click", ".js-review-init-slider", function () {
    $(this).closest(".js-review").find(".js-init-slider").trigger("click");
  });
})();
